<template>
  <div class="personalinformation">
    <span>{{msg}}</span>
  </div>
</template>

<script>
    export default {
        name: "title",
        props:{
          msg:{
            type:String
          }
        }
    }
</script>

<style scoped lang="less">
  .personalinformation {
    background-color: #ff4500;
    color: #fff;
    font-size: 16px;
    line-height: 40px;
    padding-left: 10px;
    margin: 20px 0 20px 0;
  }
</style>



// WEBPACK FOOTER //
// src/assembly/title.vue